import forge from 'node-forge';
import aesjs from 'aes-js';

// SERVER DECRYPT WITH SERVER PRIVATE KEY AND WE WILL ENCRYPT IT WITH SERVER PUBLIC KEY
function _arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}
const rsaEncryption = (publicKeyPem, key_256, iv) => {
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

  // Step 2: Prepare the data to encrypt (key and iv)
  const buffer = {
    key: _arrayBufferToBase64(key_256),
    iv: _arrayBufferToBase64(iv),
  };

  // Step 3: Encrypt the data with the public key (RSA encryption)
  const encrypted = publicKey.encrypt(forge.util.encodeUtf8(JSON.stringify(buffer)), 'RSA-OAEP');

  return forge.util.encode64(encrypted);
};
const encryptApiData = async (publicKeyPem, data) => {
  const key_256 = new Uint8Array(32); // 256 bits
  const iv = new Uint8Array(16); // 128 bits

  window.crypto.getRandomValues(key_256); // Generates a random 256-bit key
  window.crypto.getRandomValues(iv);

  const textBytes = aesjs.utils.utf8.toBytes(JSON.stringify(data));
  const aesOfb = new aesjs.ModeOfOperation.cbc(key_256, iv);
  const encryptedBytes = aesOfb.encrypt(aesjs.padding.pkcs7.pad(textBytes));
  const encryptedBase64 = _arrayBufferToBase64(encryptedBytes);
  const sendData = {
    value: encryptedBase64,
    handler: rsaEncryption(publicKeyPem, key_256, iv),
  };
  return sendData;
};
// SERVER DECRYPT WITH SERVER PRIVATE KEY AND WE WILL ENCRYPT IT WITH SERVER PUBLIC KEY

// SERVER ENCRYPT WITH OUR PUBLIC KEY AND WE WILL DECRYPT IT WITH OUR PRIVATE KEY

async function generateRSAKeys() {
  const keyPair = forge.pki.rsa.generateKeyPair(2048);
  const publicKey = forge.pki.publicKeyToPem(keyPair.publicKey);
  const privateKey = forge.pki.privateKeyToPem(keyPair.privateKey);
  return { publicKey, privateKey };
}

// SERVER ENCRYPT WITH OUR PUBLIC KEY AND WE WILL DECRYPT IT WITH OUR PRIVATE KEY

// SERVER ENCRYPT WITH CLIENT PUBLIC KEY AND WE WILL DECRYPT IT WITH CLIENT PRIVATE KEY
const base64ToUint8Array = (base64) => {
  const binaryString = atob(base64);
  const length = binaryString.length;
  const uint8Array = new Uint8Array(length);

  for (let i = 0; i < length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }

  return uint8Array;
};
const decryptData = (data, rsaData) => {
  const keyBytes = base64ToUint8Array(rsaData.key);
  const ivBytes = base64ToUint8Array(rsaData.iv);
  const aesOfb = new aesjs.ModeOfOperation.cbc(keyBytes, ivBytes);
  const encryptedBytes = base64ToUint8Array(data);
  const decryptedBytes = aesjs.padding.pkcs7.strip(aesOfb.decrypt(encryptedBytes));
  const decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
  const parsedData = JSON.parse(decryptedText);
  return parsedData;
};
const decryptApiData = async (pkcs1Pem, data) => {
  const handler = data.handler;
  const handlerValue = data.value;
  const privateKey = forge.pki.privateKeyFromPem(pkcs1Pem);
  const pkcs8Pem = forge.pki.privateKeyToPem(privateKey);
  const privateKeyPem = forge.pki.privateKeyFromPem(pkcs8Pem);
  const decrypted = JSON.parse(privateKeyPem.decrypt(forge.util.decode64(handler), 'RSA-OAEP'));
  const apiData = await decryptData(handlerValue, decrypted);
  return apiData;
};
// SERVER ENCRYPT WITH CLIENT PUBLIC KEY AND WE WILL DECRYPT IT WITH CLIENT PRIVATE KEY

const handShakeFunc = async (handshakeApi) => {
  const { publicKey, privateKey } = await generateRSAKeys();
  const handshakeResult = await handshakeApi({ publicKey }).unwrap();
  const decryptResult =
    handshakeResult.handler !== ''
      ? await decryptApiData(privateKey, handshakeResult)
      : { serverPublicKey: handshakeResult.serverPublicKey };
  return {
    ...decryptResult,
    localPublicKey: publicKey,
    localPrivateKey: privateKey,
  };
};
export { handShakeFunc, encryptApiData, decryptApiData };
